import { StyleSheet } from 'aphrodite'
import { Common } from 'styles'

const styles = StyleSheet.create({
  container: {
    order: 1,
    flexGrow: 1
  },
  menuVisible: {
    marginLeft: 0
  },
  menuNotVisible: {
    marginLeft: 0
  },
  menuHover: {
    marginLeft: `${Common.treeClosedWidth}px`
  }
})

export default styles



// WEBPACK FOOTER //
// ./src/components/App/CurrentView/styles.js